import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _dec3, _class, _class2, _div, _CircularProgressLoad;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import getVideoId from 'get-video-id';
import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Modal from '@mui/material/Modal';
import NoSsr from '@mui/material/NoSsr';
import { Interweave } from 'interweave';
import CourseItem from '../../../components/CourseItem/CourseItem';
import CircularProgressLoader from '../../../components/CircularProgressLoader/CircularProgressLoader';
import Link from '../../../components/Link/Link';
import AppContext from '../../../context';
import { getVimeoAppId, getWhitelabeledOrganizationSlug, hasMedicalLicense, isTrial } from '../../../helpers/index';
import isLoggedIn from '../../../helpers/checkAuth';
import CourseDetailsHeader from '../CourseDetailsHeader/CourseDetailsHeader';
import CourseLivestream from '../CourseLivestream/CourseLivestream';
import s from './CourseDetailsContent.scss';
import large from '../../../components/large_screen.scss';
import LessonsListItem from '../../../components/LessonsListItem/LessonsListItem';
import QuizzesListItem from '../../../components/QuizzesListItem/QuizzesListItem';
import messages from './courseDetailsContentMessages';
import CongratulationsModal from '../../lessonDetails/CongratulationsModal/CongratulationsModal';
import * as courseDetailsActions from '../../../actions/courseDetails';
import * as lessonDetailsActions from '../../../actions/lessonDetails';
import GoToNextSection from '../../lessonDetails/GoToNextSection/GoToNextSection';
import * as podcastLessonActions from '../../../actions/podcastLesson';
import * as transcodingJobsActions from '../../../actions/transcodingJobs';
import intlPropTypes from '../../../constants/intlPropTypes';
import ApprovalStepListItem from '../../../components/ApprovalStepListItem/ApprovalStepListItem';
import APPROVAL_TYPE from '../../../constants/approvalType';
import APPROVAL_STATUSES from '../../../constants/approvalStepStatuses';
import { getFirstForcedProgressionItem, isItemDisabledByForcedProgression } from '../../../helpers/forcedProgression';
var CourseDetailsContent = (_dec = withStyles(s), _dec2 = withStyles(large), _dec3 = connect(function (state) {
  return {
    auth: state.auth,
    lang: state.intl.locale,
    course: state.courseDetails.course,
    error: state.courseDetails.error,
    relatedCourses: state.courseDetails.relatedCourses,
    loadingRelatedCourses: state.courseDetails.loadingRelatedCourses,
    totalRelatedCourses: state.courseDetails.totalRelatedCourses,
    openedPodcastLesson: state.podcastLesson.openedPodcastLesson,
    nextPodcastLesson: state.podcastLesson.nextLesson
  };
}, function (dispatch) {
  return bindActionCreators(_objectSpread({
    resetCourse: courseDetailsActions.reset,
    resetLesson: lessonDetailsActions.reset,
    getLessonBySlug: lessonDetailsActions.getLessonBySlug,
    setOpenedPodcastLesson: podcastLessonActions.setOpenedPodcastLesson,
    setIsLoadingPodcastLesson: podcastLessonActions.setIsLoading,
    setNextPodcastLesson: podcastLessonActions.setNextLesson,
    resetPodcastLesson: podcastLessonActions.reset,
    setPlayPodcastAudio: podcastLessonActions.setPlayPodcastAudio
  }, transcodingJobsActions), dispatch);
}), injectIntl(_class = _dec(_class = _dec2(_class = _dec3(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(CourseDetailsContent, _React$Component);
  var _super = _createSuper(CourseDetailsContent);
  function CourseDetailsContent(_props) {
    var _this;
    _classCallCheck(this, CourseDetailsContent);
    _this = _super.call(this, _props);
    _defineProperty(_assertThisInitialized(_this), "getFirstPodcastLesson", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, getLessonBySlug, setOpenedPodcastLesson, course, setIsLoadingPodcastLesson;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$props = _this.props, getLessonBySlug = _this$props.getLessonBySlug, setOpenedPodcastLesson = _this$props.setOpenedPodcastLesson, course = _this$props.course, setIsLoadingPodcastLesson = _this$props.setIsLoadingPodcastLesson;
            setIsLoadingPodcastLesson(true);
            setOpenedPodcastLesson(_.get(course, 'sections[0].items[0].item._id'), false);
            _context.next = 5;
            return getLessonBySlug(_.get(course, 'sections[0].items[0].item.slug'), {
              courseId: _.get(course, '_id')
            });
          case 5:
            setIsLoadingPodcastLesson(false);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "getTimeLeft", function (props) {
      var timeDifference = moment.utc().diff(moment.utc(props.auth.currentTime), 'seconds');
      var end = moment.utc(props.course.liveStreamStart).format('X');
      return end - moment.utc().format('X') + timeDifference;
    });
    _defineProperty(_assertThisInitialized(_this), "countDown", function () {
      var timeLeft = _this.getTimeLeft(_this.props);
      _this.setState({
        timeLeft: timeLeft
      });
      if (_this.timer && timeLeft <= 0) {
        clearInterval(_this.timer);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "closeCongratulationsModal", function () {
      _this.setState({
        isCongratulationsModalOpened: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "goToNextPodcastLesson", function (lesson) {
      var _this$props2 = _this.props,
        course = _this$props2.course,
        setNextPodcastLesson = _this$props2.setNextPodcastLesson,
        setPlayPodcastAudio = _this$props2.setPlayPodcastAudio;
      var stateGoToNextSectionItemProgress = _this.state.goToNextSectionItemProgress;
      var lessonsAndQuizzes = _(course && course.sections || []).map('items').flatten().value();
      var lessonIndex = _.findIndex(lessonsAndQuizzes, function (item) {
        return item.item._id === _.get(lesson, '_id');
      });
      if (lessonsAndQuizzes.length - 1 === lessonIndex) {
        return;
      }
      if (_.get(lessonsAndQuizzes[lessonIndex], 'isCompleted') === false && _.subtract(_.get(course, 'totalLessons'), _.get(course, 'completedLessons')) === 1 || stateGoToNextSectionItemProgress !== 0) {
        return;
      }
      var nextItem = lessonsAndQuizzes[lessonIndex + 1];
      setNextPodcastLesson(nextItem);
      setPlayPodcastAudio(false);
      var timeout = 7000; // todo move it to config
      var startTs = Date.now();
      _this.invervalTimer = setInterval(function () {
        var goToNextSectionItemProgress = (Date.now() - startTs) / timeout * 100;
        if (goToNextSectionItemProgress > 100) {
          clearInterval(_this.invervalTimer);
          return;
        }
        _this.setState({
          goToNextSectionItemProgress: goToNextSectionItemProgress
        });
      }, 20);
      _this.timeoutTimer = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.loadNextItem();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })), timeout);
    });
    _defineProperty(_assertThisInitialized(_this), "cancelGoToNextSectionItem", function () {
      clearTimeout(_this.timeoutTimer);
      clearInterval(_this.invervalTimer);
      _this.setState({
        goToNextSectionItemProgress: 0
      });
    });
    _defineProperty(_assertThisInitialized(_this), "loadNextItem", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this$props3, course, getLessonBySlug, setOpenedPodcastLesson, setIsLoadingPodcastLesson, resetLesson, nextPodcastLesson;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _this$props3 = _this.props, course = _this$props3.course, getLessonBySlug = _this$props3.getLessonBySlug, setOpenedPodcastLesson = _this$props3.setOpenedPodcastLesson, setIsLoadingPodcastLesson = _this$props3.setIsLoadingPodcastLesson, resetLesson = _this$props3.resetLesson, nextPodcastLesson = _this$props3.nextPodcastLesson;
            _this.cancelGoToNextSectionItem();
            resetLesson();
            setIsLoadingPodcastLesson(true);
            setOpenedPodcastLesson(_.get(nextPodcastLesson, 'item._id'), true, true);
            _context3.next = 7;
            return getLessonBySlug(_.get(nextPodcastLesson, 'item.slug'), {
              courseId: _.get(course, '_id')
            });
          case 7:
            setIsLoadingPodcastLesson(false);
          case 8:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    _defineProperty(_assertThisInitialized(_this), "logSearchSessionCourseOpened", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _this$props4, course, searchSessionId, auth;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _this$props4 = _this.props, course = _this$props4.course, searchSessionId = _this$props4.searchSessionId, auth = _this$props4.auth;
            if (!(!searchSessionId || !isLoggedIn(auth))) {
              _context4.next = 3;
              break;
            }
            return _context4.abrupt("return");
          case 3:
            _context4.prev = 3;
            _context4.next = 6;
            return _this.context.fetch("/api/courses/search-session/".concat(searchSessionId, "/log-item"), {
              method: 'PATCH',
              body: JSON.stringify({
                courseIdOpenedBySearch: course === null || course === void 0 ? void 0 : course._id
              })
            });
          case 6:
            _context4.next = 11;
            break;
          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](3);
            console.error(_context4.t0);
          case 11:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[3, 8]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "trackGACourseView", function () {
      var _this$props5 = _this.props,
        course = _this$props5.course,
        auth = _this$props5.auth;
      if (window && window !== undefined) {
        var _auth$user, _auth$user$mainGroup, _auth$user2, _auth$user2$mainGroup;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'course_view',
          organization_slug: getWhitelabeledOrganizationSlug(auth) || null,
          organization_id: (auth === null || auth === void 0 ? void 0 : (_auth$user = auth.user) === null || _auth$user === void 0 ? void 0 : (_auth$user$mainGroup = _auth$user.mainGroup) === null || _auth$user$mainGroup === void 0 ? void 0 : _auth$user$mainGroup._id) || null,
          organization_name: (auth === null || auth === void 0 ? void 0 : (_auth$user2 = auth.user) === null || _auth$user2 === void 0 ? void 0 : (_auth$user2$mainGroup = _auth$user2.mainGroup) === null || _auth$user2$mainGroup === void 0 ? void 0 : _auth$user2$mainGroup.name) || null,
          is_course_public: (course === null || course === void 0 ? void 0 : course.isPublic) || false,
          course_name: course === null || course === void 0 ? void 0 : course.name,
          course_id: course === null || course === void 0 ? void 0 : course._id
        });
      }
    });
    var _timeLeft = _props.course.type === 'livestream' ? _this.getTimeLeft(_props) : 0;
    _this.state = {
      timeLeft: _timeLeft,
      isCongratulationsModalOpened: false,
      goToNextSectionItemProgress: 0
    };
    if (_props.course.type === 'livestream') {
      var video = getVideoId(_props.course.youtubeVideoUrl);
      _this.state.videoId = video.id;
      _this.state.videoService = video.service;
      _this.state.videoAppId = _this.state.videoService !== 'vimeo' ? '' : getVimeoAppId(_props.course.youtubeVideoUrl);
    }
    _this.timer = null;
    return _this;
  }
  _createClass(CourseDetailsContent, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this$props$course, _this$props$course$se, _this$props$course$se2, _this$props$course$se3, _this$props$course$se4, lessonsIds;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this.props.course.type === 'livestream') {
                this.timer = setInterval(this.countDown, 1000);
              }
              if (_.get(this, 'props.course.type') === 'podcast' && this.props.course.totalLessons === 1) {
                this.getFirstPodcastLesson();
              }
              this.trackGACourseView();
              this.logSearchSessionCourseOpened();
              if (_.get(this, 'props.course.type') === 'podcast') {
                lessonsIds = (_this$props$course = this.props.course) === null || _this$props$course === void 0 ? void 0 : (_this$props$course$se = _this$props$course.sections) === null || _this$props$course$se === void 0 ? void 0 : (_this$props$course$se2 = _this$props$course$se.map(function (section) {
                  return section.items;
                })) === null || _this$props$course$se2 === void 0 ? void 0 : (_this$props$course$se3 = _this$props$course$se2.flat()) === null || _this$props$course$se3 === void 0 ? void 0 : (_this$props$course$se4 = _this$props$course$se3.filter(function (item) {
                  return item.itemType === 'Lesson';
                })) === null || _this$props$course$se4 === void 0 ? void 0 : _this$props$course$se4.map(function (i) {
                  return _.get(i, 'item._id');
                });
                if (lessonsIds !== null && lessonsIds !== void 0 && lessonsIds.length) {
                  this.props.getTranscodingJobs({
                    lessonId: lessonsIds,
                    page: 1,
                    perPage: 50,
                    'status[0]': 'pending',
                    'status[1]': 'processing',
                    sort: '-createDate'
                  });
                }
              }
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (_.get(this, 'props.course.type') === 'podcast') {
        if (_.get(this, 'props.course._id') === _.get(prevProps, 'course._id') && _.get(this, 'props.course.progress') === 100 && _.get(prevProps, 'course.progress') !== 100) {
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState({
            isCongratulationsModalOpened: true
          });
        }
        if (!_.get(this, 'props.nextPodcastLesson.item._id') && _.get(prevProps, 'nextPodcastLesson.item._id') && this.state.goToNextSectionItemProgress) {
          this.cancelGoToNextSectionItem();
        }
        if (_.get(this, 'props.course._id') !== _.get(prevProps, 'course._id') && this.props.course.totalLessons === 1) {
          this.cancelGoToNextSectionItem();
          this.props.setOpenedPodcastLesson(null);
          this.getFirstPodcastLesson();
        }
        if (_.get(this, 'props.course._id') !== _.get(prevProps, 'course._id') && this.props.course.totalLessons !== 1) {
          this.props.setOpenedPodcastLesson(null);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var course = this.props.course;
      if (course.type === 'livestream' && this.timer) {
        clearInterval(this.countDown);
      }
      if (course.type === 'podcast') {
        this.props.resetLesson();
        this.cancelGoToNextSectionItem();
        this.props.resetPodcastLesson();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props6 = this.props,
        course = _this$props6.course,
        auth = _this$props6.auth,
        error = _this$props6.error,
        relatedCourses = _this$props6.relatedCourses,
        loadingRelatedCourses = _this$props6.loadingRelatedCourses,
        formatMessage = _this$props6.intl.formatMessage,
        openedPodcastLesson = _this$props6.openedPodcastLesson,
        nextPodcastLesson = _this$props6.nextPodcastLesson;
      var _this$state = this.state,
        timeLeft = _this$state.timeLeft,
        videoId = _this$state.videoId,
        videoService = _this$state.videoService,
        videoAppId = _this$state.videoAppId,
        isCongratulationsModalOpened = _this$state.isCongratulationsModalOpened,
        goToNextSectionItemProgress = _this$state.goToNextSectionItemProgress;
      var courseItems = _(course && course.sections || []).filter(function (section) {
        return !section.isContentHidden;
      }).map('items').flatten().value();
      var isApprovalStepCompleted = function isApprovalStepCompleted(sectionItem) {
        return sectionItem.itemType === 'Approval' && (sectionItem.isCompleted || sectionItem.approvalStatus === APPROVAL_STATUSES.APPROVED);
      };
      var firstIncompleteBlockProgressApprovalIndex = courseItems.findIndex(function (sectionItem) {
        return sectionItem.itemType === 'Approval' && _.get(sectionItem, 'item.approvalType') === APPROVAL_TYPE.BLOCK_PROGRESS && !isApprovalStepCompleted(sectionItem);
      });
      var getSectionItemIndex = function getSectionItemIndex(sectionItem) {
        return courseItems.findIndex(function (item) {
          return _.get(item, '_id') === _.get(sectionItem, '_id');
        });
      };
      var isSectionItemBlockedByApprovalStep = function isSectionItemBlockedByApprovalStep(sectionItem) {
        var index = getSectionItemIndex(sectionItem);
        return firstIncompleteBlockProgressApprovalIndex !== -1 && index > firstIncompleteBlockProgressApprovalIndex;
      };
      var isCertificateBlocked = courseItems.some(function (sectionItem) {
        return sectionItem.itemType === 'Approval' && _.get(sectionItem, 'item.approvalType') === APPROVAL_TYPE.BLOCK_CERTIFICATE && !isApprovalStepCompleted(sectionItem);
      });
      var firstForcedProgressionItem = getFirstForcedProgressionItem(course);
      var isSectionItemDisabledByForcedProgression = function isSectionItemDisabledByForcedProgression(sectionItem) {
        return isItemDisabledByForcedProgression(course, sectionItem, firstForcedProgressionItem);
      };
      if (error) {
        return /*#__PURE__*/_jsx("div", {
          className: s.root
        }, void 0, /*#__PURE__*/_jsx("div", {
          className: s.container
        }, void 0, /*#__PURE__*/_jsx("div", {
          className: s.loadingWrapper
        }, void 0, /*#__PURE__*/_jsx(Typography, {
          gutterBottom: true,
          color: "error"
        }, void 0, error.error))));
      }
      var renderSection = function renderSection(section) {
        var completedLessons = section.completedLessons;
        return /*#__PURE__*/_jsx("div", {
          className: classNames(s.flex, s.spaceBetween, s.flexWrapOnMobile)
        }, section._id, !course.hideSectionTitle ? /*#__PURE__*/_jsx(Typography, {
          className: s.sectionName
        }, void 0, section.name) : _div || (_div = /*#__PURE__*/_jsx("div", {})), isLoggedIn(auth) && /*#__PURE__*/_jsx(Tooltip, {
          title: formatMessage(messages.completedItemsInSection, {
            completedLessons: completedLessons,
            completedQuizzes: section.completedQuizzes,
            totalLessons: section.totalLessons,
            totalQuizzes: section.totalQuizzes
          })
        }, void 0, /*#__PURE__*/_jsx(Typography, {
          className: s.sectionStat
        }, void 0, completedLessons + section.completedQuizzes, " /", ' ', section.totalLessons + section.totalQuizzes)));
      };
      var renderSectionItems = function renderSectionItems(section) {
        if (section.isContentHidden) {
          return /*#__PURE__*/_jsx("div", {
            className: s.hiddenNote
          }, void 0, /*#__PURE__*/_jsx(Typography, {}, void 0, /*#__PURE__*/_jsx(NoSsr, {}, void 0, /*#__PURE__*/_jsx(Interweave, {
            content: section.hiddenNote
          }))));
        }
        return _(section.items).map(function (sectionItem) {
          if (sectionItem.itemType === 'Lesson') {
            return /*#__PURE__*/_jsx(LessonsListItem, {
              item: _.get(sectionItem, 'item', {}),
              isCompleted: sectionItem.isCompleted,
              course: course,
              showPodcastContent: openedPodcastLesson === _.get(sectionItem, 'item._id', undefined),
              goToNextPodcastLesson: _this2.goToNextPodcastLesson,
              cancelGoToNextSectionItem: _this2.cancelGoToNextSectionItem,
              disabled: isSectionItemBlockedByApprovalStep(sectionItem) || isSectionItemDisabledByForcedProgression(sectionItem) || course.forceCourseRestartForTask
            }, "".concat(section._id, "_").concat(_.get(sectionItem, 'item._id', '')));
          }
          if (sectionItem.itemType === 'Quiz') {
            return /*#__PURE__*/_jsx(QuizzesListItem, {
              disabled: isSectionItemBlockedByApprovalStep(sectionItem) || isSectionItemDisabledByForcedProgression(sectionItem) || course.forceCourseRestartForTask,
              item: _.get(sectionItem, 'item', {}),
              isCompleted: sectionItem.isCompleted,
              course: course
            }, "".concat(section._id, "_").concat(_.get(sectionItem, 'item._id', '')));
          }
          if (sectionItem.itemType === 'Approval') {
            return /*#__PURE__*/_jsx(ApprovalStepListItem, {
              disabled: isSectionItemBlockedByApprovalStep(sectionItem) || isSectionItemDisabledByForcedProgression(sectionItem) || course.forceCourseRestartForTask,
              item: _.get(sectionItem, 'item', {}),
              isCompleted: sectionItem.isCompleted,
              course: course,
              status: sectionItem === null || sectionItem === void 0 ? void 0 : sectionItem.approvalStatus
            }, "".concat(section._id, "_").concat(_.get(sectionItem, 'item._id', ''), "_").concat(sectionItem === null || sectionItem === void 0 ? void 0 : sectionItem.approvalStatus, "_").concat(sectionItem.isCompleted));
          }
          return null;
        }).value();
      };
      var streamingNow = false;
      if (course.type === 'livestream' && timeLeft <= 0 && moment(course.liveStreamEnd).diff(moment()) > 0) {
        streamingNow = true;
      }
      return /*#__PURE__*/_jsx("main", {
        className: classNames(s.root, _defineProperty({}, s.livestream, course.type === 'livestream'))
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.container
      }, void 0, course.type === 'livestream' && /*#__PURE__*/_jsx(CourseLivestream, {
        streamingNow: streamingNow,
        videoService: videoService,
        videoAppId: videoAppId,
        videoId: videoId,
        timeLeft: timeLeft
      }), /*#__PURE__*/_jsx(CourseDetailsHeader, {
        streamingNow: streamingNow,
        timeLeft: timeLeft,
        videoService: videoService,
        videoAppId: videoAppId,
        videoId: videoId,
        getFirstPodcastLesson: this.getFirstPodcastLesson,
        disableContinueToBtn: goToNextSectionItemProgress !== 0
      }), course.type !== 'livestream' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx("section", {
        className: classNames(s.sectionsBlock, large.generalSection)
      }, void 0, _.get(course, 'sections', []).map(function (section, index) {
        return /*#__PURE__*/_jsx("div", {
          className: s.sectionBlock
        }, section._id, (course.type !== 'podcast' || course.type === 'podcast' && course.totalLessons !== 1) && renderSection(section, index), /*#__PURE__*/_jsx(List, {
          component: "div",
          disablePadding: true
        }, void 0, renderSectionItems(section)));
      })), /*#__PURE__*/_jsx("section", {
        className: classNames(s.authorsAndRelatedCoursesBlock, large.generalSection)
      }, void 0, course && !_.isEmpty(course.authors) && /*#__PURE__*/_jsx("div", {
        className: s.authorsBlock
      }, void 0, /*#__PURE__*/_jsx(Typography, {
        className: s.title
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.courseAuthorsTitle)), /*#__PURE__*/_jsx("div", {
        className: s.authorsList
      }, void 0, _.get(course, 'authors', []).map(function (author) {
        return /*#__PURE__*/_jsx("div", {
          className: s.authorItem
        }, author._id, /*#__PURE__*/_jsx(Avatar, {
          className: s.authorItemDetailsAvatar,
          alt: author.name,
          src: _.get(author, 'image.path') ? "".concat(_this2.context.cloudfrontUrl, "/").concat(_.get(author, 'image.path')) : '/icons/noprofilephoto.png'
        }), /*#__PURE__*/_jsx("div", {
          className: s.authorItemDetails
        }, void 0, /*#__PURE__*/_jsx(Typography, {
          className: s.authorItemDetailsPersonName
        }, void 0, author.name), /*#__PURE__*/_jsx(Typography, {
          className: s.authorItemDetailsPersonPosition
        }, void 0, author.profession)));
      }))), !_.isEmpty(relatedCourses) && /*#__PURE__*/_jsx("div", {
        className: s.relatedCoursesBlock
      }, void 0, /*#__PURE__*/_jsx(Typography, {
        className: s.title
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.relatedCoursesLabel)), loadingRelatedCourses && (_CircularProgressLoad || (_CircularProgressLoad = /*#__PURE__*/_jsx(CircularProgressLoader, {}))), !loadingRelatedCourses && /*#__PURE__*/_jsx(Grid, {
        className: s.gridList,
        spacing: 1,
        container: true
      }, void 0, relatedCourses.map(function (item) {
        var _classNames2;
        return /*#__PURE__*/_jsx(Grid, {
          xs: 12,
          sm: 4,
          md: 6,
          lg: 4,
          className: classNames((_classNames2 = {}, _defineProperty(_classNames2, s.relatedCourseListItem, true), _defineProperty(_classNames2, s.moreItems, _.isEmpty(course.authors)), _classNames2)),
          item: true
        }, item._id, /*#__PURE__*/_jsx(CourseItem, {
          item: item
        }));
      })), relatedCourses.length >= 6 && /*#__PURE__*/_jsx("div", {
        className: s.loadMoreButtonWrapper
      }, void 0, /*#__PURE__*/_jsx(Button, {
        variant: "contained",
        color: "primary",
        size: "large",
        to: "/",
        component: Link
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.loadMoreBtnLabel))))))), course._id && /*#__PURE__*/_jsx(Modal, {
        open: isCongratulationsModalOpened,
        onClose: this.closeCongratulationsModal
      }, void 0, /*#__PURE__*/_jsx(CongratulationsModal, {
        onClose: this.closeCongratulationsModal,
        course: course,
        hideCertificateBtn: hasMedicalLicense(auth.user && auth.user.mainGroup) || !course.assignCertificate || isTrial(auth) || isCertificateBlocked
      })), goToNextSectionItemProgress !== 0 && !isCongratulationsModalOpened && _.get(nextPodcastLesson, '_id') && /*#__PURE__*/_jsx(NoSsr, {}, void 0, /*#__PURE__*/_jsx(GoToNextSection, {
        nextItem: nextPodcastLesson,
        goToNextSectionItemProgress: goToNextSectionItemProgress,
        cancelGoToNextSectionItem: this.cancelGoToNextSectionItem,
        nextPodcastItemClickHandler: this.loadNextItem
      })));
    }
  }]);
  return CourseDetailsContent;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  openedPodcastLesson: '',
  searchSessionId: ''
}), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class) || _class) || _class);
export { CourseDetailsContent as default };